import React from "react";
import TokenLogin from "../components/Token-Login";
import { Route } from "react-router-dom";
import SecureRoute from "./secure-route";

const defaultProps = {
  path: "/",
  element: undefined,
  key: 0,
};

export default function PrivateRoute(props = defaultProps) {
  return (
    <Route
      key={props.key}
      path={props.path}
      element={
        <>
          <TokenLogin route={props.path} redirect={true} />
          <SecureRoute />
          {props.element}
        </>
      }
    />
  );
}
